import { useContext } from 'react';
import TrackWrapper from '@/common/TrackWrapper';
import SectionWrapper from '@/home/common/SectionWrapper';
import { FinanceCard, TradeCard } from '@/home/ReturnUser/HeroCards/Cards';
import {
  FinanceTradeWrapper,
  GridWrapper,
  HeroFavoriteAndSearchCard
} from '@/home/ReturnUser/HeroCards/HeroCards.styles';
import SRPLinks from '@/home/ReturnUser/HeroCards/LinkCards/SRPLinks';
import VDPLinks from '@/home/ReturnUser/HeroCards/LinkCards/VDPLinks';
import { vexBlobUrl } from '~/constants/environment';
import { useConsumer } from '~/context/common/StaticContext';
import { useGetUser } from '~/context/common/UserContext';
import UserPurchaseContext from '~/context/home/UserPurchaseContext';
import formatEvent from '~/utilities/formatEvent';
import KeepShoppingBand from './KeepShoppingBand';
import OrderStatusCard from './OrderStatusCard';
import { getOrderStatusCardConfig } from './utils';
import VehicleHeroImage from './VehicleHeroImage';

export default function OrderStatusModule() {
  const {
    userPurchase: {
      data: { openVerifications, orderState, vehicle }
    }
  } = useContext(UserPurchaseContext);
  const consumer = useConsumer();
  const user = useGetUser();

  if (!vehicle) return null;

  const { make, stockNumber, vehicleId } = vehicle;

  const givenName = user?.given_name ?? '';

  const config = getOrderStatusCardConfig({
    consumer,
    givenName,
    make,
    openVerifications,
    orderState,
    vehicleId
  });

  const primaryImageUrl = `${vexBlobUrl}/${stockNumber}/standardHeroWithNoLetters_3ft.jpg`;
  const fallbackImageUrl = `${vexBlobUrl}/${stockNumber}/vdpHeliosTablet.jpg`;

  const cardProps = { config, orderState, vehicle };

  return (
    <div className="flex w-full flex-col bg-background-default">
      <TrackWrapper
        event={formatEvent('Home feed card', {
          action: 'viewed',
          description: 'Order Status Card',
          status: orderState,
          vehicleId
        })}
      >
        <VehicleHeroImage
          fallbackImageUrl={fallbackImageUrl}
          primaryImageUrl={primaryImageUrl}
        >
          <OrderStatusCard {...cardProps} />
        </VehicleHeroImage>
      </TrackWrapper>

      <KeepShoppingBand />

      <SectionWrapper
        analyticsSection="Hero Cards"
        className="pt-24 sm:pt-4xl"
        hasSideSpacing
        hasBottomSpacing
      >
        <GridWrapper>
          <HeroFavoriteAndSearchCard>
            <VDPLinks />
          </HeroFavoriteAndSearchCard>
          <HeroFavoriteAndSearchCard>
            <SRPLinks />
          </HeroFavoriteAndSearchCard>
          <FinanceTradeWrapper>
            <FinanceCard />
            <TradeCard />
          </FinanceTradeWrapper>
        </GridWrapper>
      </SectionWrapper>
    </div>
  );
}
